import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ChunkLoadError from './Errors/ChunkLoadError/ChunkLoadError';
import Maintenance from '../shared/components/Error/Maintenance';
import { ERRORS } from '../shared/utils/constants/error';

// Currently cannot be implemented via hooks
// Not sure where this component should sit within directory
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  // EventListener for error is added to handle 503 error that is not caught by ErrorBoundary
  componentDidMount() {
    window.addEventListener('error', this.onUnhandledRejection.bind(this));
  }

  componentDidCatch(error, errorInfo) {
    // Todo: Rollbar handling should be added here
    console.log(error, errorInfo);
  }

  componentWillUnmount() {
    window.removeEventListener('error', this.onUnhandledRejection);
  }

  onUnhandledRejection(event) {
    if (event?.error?.name === ERRORS.maintenance.name) {
      this.setState({
        hasError: true,
        error: event.error,
      });
    }
  }

  render() {
    const { error, hasError } = this.state;
    const { children } = this.props;

    if (hasError && error) {
      switch (error.name) {
        case ERRORS.chunkLoadError.name:
          return <ChunkLoadError />;
        case ERRORS.maintenance.name:
          return <Maintenance />;
        default:
          return <h1>Something went wrong...</h1>;
      }
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
